import { createSlice } from '@reduxjs/toolkit';
import _sortBy from 'lodash/sortBy';

import albumsDataRaw from 'data/albums.json';
import songsDataRaw from 'data/songs.json';

import { SongsState, Album, Song } from 'interfaces';

const initialStateDefault: SongsState = {
  songDetails: null,
  songs: [],
  albumDetails: null,
  internationalAlbumDetails: null,
  lyrics: ''
};

const albumsData: Album[] = albumsDataRaw as unknown as Album[];
const songsData: Song[] = songsDataRaw as unknown as Song[];

const songsSlice = createSlice({
  name: 'songs',
  initialState: initialStateDefault,
  reducers: {
    loadSongs (state) {
      const newList: Song[] = [];
      songsData.forEach((song) => {
        const album = albumsData.filter((album) => album.id === song.albumId)[0];
        newList.push({
          ...song,
          albumName: album.name,
          albumEnglishName: album.englishName,
          releaseDate: song.singleRelease || album.releaseDate
        })
      });

      const sortedNewList = _sortBy(newList, 'releaseDate');

      return {
        ...state,
        songs: sortedNewList
      };
    },
    getSongDetails (state, action) {
      const { songId } = action.payload;

      const songDetails = songsData.filter((el) => el.id === songId)[0];
      const albumDetails = albumsData.filter((el) => el.id === songDetails.albumId && el.international === false)?.[0];
      const internationalAlbumDetails = albumsData.filter((el) => el.id === songDetails.albumId && el.international)?.[0];

      return {
        ...state,
        songDetails,
        albumDetails,
        internationalAlbumDetails
      };
    }
  }
});

export const { loadSongs, getSongDetails } = songsSlice.actions;

export default songsSlice.reducer;
